import { LOGIN_STATE_SENTINEL } from "@shared/constants";

import { randomString } from "../crypto";
import { getSafeRedirect } from "../getSafeRedirect";
import { recoverBrowserSecurityError } from "../storage";

export const redirectToExternal = (
  urlString: string,
  returnPath?: string | null
) => {
  const authSentinel = randomString(45);
  recoverBrowserSecurityError(() => {
    localStorage.setItem(LOGIN_STATE_SENTINEL, authSentinel);
  });
  const url = new URL(urlString);
  const redirect = getSafeRedirect(returnPath);
  url.searchParams.set("state", `${authSentinel}-${redirect}`);
  window.location.replace(url.toString());
};
